<template>
    <v-dialog name="editRow" v-model="level.dialogValues.dialogShow" data-app="true" persistent max-width="900">
      <v-card>

        <CardUpdatableHeader :row="row" :level="level">
          <template slot="title_create">
            <span class="headline">{{ $t('texts.cusser_create_title') }}</span>            
         </template>
          <template slot="title_update">
            <span class="headline">{{ $t('texts.cusser_update_title') }}</span>            
         </template>
          <template slot="title_delete">
            <span class="headline">{{ $t('texts.cusser_delete_title') }}</span>            
         </template>
          <template slot="subheader">
            <span>pour le client {{level.customer.cus_name}} ({{level.customer.cus_code}})</span>
         </template>
        </CardUpdatableHeader>

         <v-card-text>
            <v-container>
               <v-row>
                  <v-col v-if="!level.dialogValues.form_create" cols="auto">
                     <b-badge class="m-1" variant="info">{{ $t('headers.created_on') }}</b-badge>{{ $api._d(row.xxx_create,'long') }}<br/>
                     <b-badge class="m-1" variant="info">{{ $t('headers.updated_on') }}</b-badge>{{ $api._d(row.xxx_create,'long') }}
                  </v-col>
               </v-row>

            </v-container>

         </v-card-text>

        <CardUpdatableFooter :row="row" :level="level"/>

      </v-card>
    </v-dialog>

</template>

<script>
import i18n from '@/plugins/i18n.js';
import ddoAlert from '@/components/ddoAlert.vue';
import CardUpdatable from '@/components/partials/CardUpdatable.vue';
import CardUpdatableHeader from '@/components/partials/CardUpdatableHeader.vue';
import CardUpdatableFooter from '@/components/partials/CardUpdatableFooter.vue';
import ddoSelectMailprofile from '@/components/ddoSelectMailprofile.vue';

export default {
   name: 'CardUpdatableCUSPLFSLA',
   extends: CardUpdatable,
   components: {
      ddoAlert,
      CardUpdatableHeader,
      CardUpdatableFooter,
      ddoSelectMailprofile
   },
   data: function () {
      return {
         callbacks: {
         },
         items_warn_levels: [ { value: 0, text: i18n.t('texts.level_ok') }, { value: 1, text: i18n.t('texts.level_warning') }, { value: 2, text: i18n.t('texts.level_error') }  ],
      }
   },

   created() {
   },

   mounted() {
   },

   methods: {
   }
}
</script>